import type {
  Agreement,
  GeoLocation,
  Partnership,
  ProductAdditionalInfo,
  ProductListItem,
} from 'app/src/services/welfareportal/companyagreement-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const geoLocationSchema: z.ZodType<GeoLocation> = z.object({
  latitude: z.number(),
  longitude: z.number(),
})

export const partnershipInfoSchema: z.ZodType<Partnership> = z.object({
  description: z.string(),
  link: z.string(),
})

export const agreementSchema: z.ZodType<Agreement> = z.object({
  description: z.string(),
  link: z.string(),
})

export const additionalInfoSchema: z.ZodType<ProductAdditionalInfo> = z.object({
  partnership: partnershipInfoSchema.optional(),
  agreement: agreementSchema.optional(),
  informativeMessage: z.string().optional(),
})

export const productSchema: z.ZodType<ProductListItem> = z.object({
  productId: z.string().optional(),
  productName: z.string().optional(),
  description: z.string().optional(),
  mainImage: z.string().optional(),
  geoLocation: geoLocationSchema.optional(),
  geoAddress: z.string().optional(),
  weight: z.number().optional(),
  isFavourite: z.boolean().optional(),
})
